import React from "react";

import { translate } from "react-i18next";

import Carousel from "./carousel";

// See https://facebook.github.io/react/docs/forms.html for documentation about forms.
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <div className="container marketing">
          <Carousel />
          <div className="row">
            <div className="col-lg-4">
              <img
                className="img-circle"
                src={process.env.PUBLIC_URL + "/assets/images/chinese-food-dishes.svg"}
                alt="Logo_S"
                width="140"
                height="140"
              />
              <h2>{t("projectName")}</h2>
              <p>
                Donec sed odio dui. Etiam porta sem malesuada magna mollis
                euismod. Nullam id dolor id nibh ultricies vehicula ut id elit.
                Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                Praesent commodo cursus magna.
              </p>
              <p>
                <a
                  className="btn btn-default"
                  href={process.env.PUBLIC_URL + "/#/about"}
                  role="button"
                  target="blank"
                >
                  {t("viewDetails")}
                </a>
              </p>
            </div>
            <div className="col-lg-4">
              <img
                className="img-circle"
                src={process.env.PUBLIC_URL + "/assets/images/team-work.jpg"}
                alt="PS  "
                width="140"
                height="140"
              />
              <h2>{t("Team")}</h2>
              <p>
                Duis mollis, est non commodo luctus, nisi erat porttitor ligula,
                eget lacinia odio sem nec elit. Cras mattis consectetur purus
                sit amet fermentum. Fusce dapibus, tellus ac cursus commodo,
                tortor mauris condimentum nibh.
              </p>
              <p>
                <a
                  className="btn btn-default"
                  href="http://www.psoffice.net"
                  role="button"
                  target="blank"
                >
                  {t("viewDetails")} »
                </a>
              </p>
            </div>

            <div className="col-lg-4">
              <img
                className="img-circle"
                src={process.env.PUBLIC_URL + "/assets/images/articles.jpg"}
                alt="test image2"
                width="140"
                height="140"
              />
              <h2>{t("articles")}</h2>
              <p>
                Donec sed odio dui. Cras justo odio, dapibus ac facilisis in,
                egestas eget quam. Vestibulum id ligula porta felis euismod
                semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris
                condimentum nibh, ut fermentum massa justo sit amet risus.
              </p>
              <p>
                <a
                  className="btn btn-default"
                  href="http://www.psoffice.net"
                  role="button"
                  target="blank"
                >
                  {t("viewDetails")} »
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(Home);
